import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = {
  key: 0,
  class: "form-entity d-flex justify-content-end align-items-center"
}
const _hoisted_3 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_4 = {
  class: "btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = {
  class: "d-flex align-items-center ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_9 = {
  class: "cursor-pointer symbol symbol-30px symbol-md-40px",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showEntity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_select, {
            id: "entity",
            modelValue: _ctx.entity,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity) = $event)),
            onChange: _ctx.handleChange,
            disabled: _ctx.disableEntity
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange", "disabled"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isCurrentSystem('base'))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: '/profile/settings'
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg, {
                    src: 
                require('../../assets/media/icons/duotune/coding/cod001.svg')
              
                  }, null, 8, ["src"])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _ctx.baseUrl + '/#/profile/settings'
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_inline_svg, {
                  src: 
                require('../../assets/media/icons/duotune/coding/cod001.svg')
              
                }, null, 8, ["src"])
              ])
            ], 8, _hoisted_6))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          src: require('../../assets/media/avatars/blank.png'),
          alt: "user"
        }, null, 8, _hoisted_10)
      ]),
      _createVNode(_component_KTUserMenu)
    ])
  ]))
}